import { getStore } from "app/configureStore";

export default varName => getStore().getState().envVars[varName];
